const guiColors = {
    'motion-primary': 'oklab(0.65 0.15 -0.04)',
    'motion-primary-transparent': 'oklab(0.65 0.15 -0.04 / 0.75)',
    'motion-tertiary': 'oklab(0.47 0.19 -0.02)',

    'looks-secondary': 'oklab(0.65 0.15 -0.04)',
    'looks-transparent': 'oklab(0.65 0.15 -0.04 / 0.35)',
    'looks-light-transparent': 'oklab(0.65 0.15 -0.04 / 0.15)',
    'looks-secondary-dark': 'oklab(0.47 0.19 -0.02)',

    'extensions-primary': 'oklab(0.78 0.09 0.12)',
    'extensions-tertiary': 'oklab(0.57 0.17 0.11)',
    'extensions-transparent': 'oklab(0.78 0.09 0.12 / 0.35)',
    'extensions-light': 'oklab(0.85 0.07 0.02)',

    'drop-highlight': 'oklab(0.78 0.09 0.12)',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'oklab(0.57 0.17 0.11 / 0.75) 0%, ' +
        'oklab(0.78 0.09 0.12 / 0.75) 25%, ' +
        'oklab(1.00 0.00 0.00 / 0.75) 50%, ' +
        'oklab(0.65 0.15 -0.04 / 0.75) 75%, ' +
        'oklab(0.47 0.19 -0.02 / 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: 'oklab(0.65 0.15 -0.04)',
    checkboxActiveBorder: 'oklab(0.47 0.19 -0.02)'
};

export {
    guiColors,
    blockColors
};
